const setUser = (userObj) => {
  let user = JSON.stringify(userObj)
  sessionStorage.setItem('user', user)
}

const isJwtExpired = (jwt) => {
  if (!jwt || typeof jwt !== 'string') return true
  const part = jwt.split('.')[1]
  if (!part) return true
  try {
    const padded = part.replace(/-/g, '+').replace(/_/g, '/')
    const json = atob(
      padded.padEnd(padded.length + ((4 - (padded.length % 4)) % 4), '=')
    )
    const payload = JSON.parse(json)
    if (!payload?.exp) return false
    return payload.exp * 1000 <= Date.now()
  } catch {
    return true
  }
}

const getUser = () => {
  let user = sessionStorage.getItem('user')
  user = JSON.parse(user)
  if (!user) return undefined
  if (user.jwt && isJwtExpired(user.jwt)) {
    sessionStorage.removeItem('user')
    return undefined
  }
  return user
}

const token = () => {
  const user = getUser()
  if (user) {
    return user.jwt
  }
  return undefined
}

const isLoggedIn = () => {
  const user = getUser()
  if (!user) return false
  return Object.keys(user).length !== 0
}

const logoutUser = () => {
  sessionStorage.removeItem('user')
}

const isOrganizer = () => {
  const jwt = getUser()
  if (!jwt) return false
  return jwt.user.role.name === 'Organizer'
}

const setLastKnown = (path) => {
  sessionStorage.setItem('location', path)
}

export default {
  setUser,
  getUser,
  isLoggedIn,
  logoutUser,
  token,
  isOrganizer,
  setLastKnown,
}
